import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import { ProposedSolutionStep } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type MovableContractFormType = {
  readonly partnerId: string;
  readonly newPartnerId?: string;
  readonly contractAnniversaryDate?: string;
  readonly insuranceAmount?: number;
  readonly newInsuranceAmount?: number;
  readonly frequency: string;
  readonly newFrequency: string;
  readonly proposedSolutionStepType: string;
  readonly note?: string;
};

export const getMovableContractFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<MovableContractFormType> = (t) => {
  return object({
    partnerId: string().required(t(Resources.Validation.Required)),
    newPartnerId: string().when("proposedSolutionStepType", (proposedSolutionStepType, schema) => {
      return proposedSolutionStepType[0] === ProposedSolutionStep.keep ? schema : schema.required(t(Resources.Validation.Required));
    }),
    contractAnniversaryDate: string(),
    insuranceAmount: number(),
    newInsuranceAmount: number().when("proposedSolutionStepType", (proposedSolutionStepType, schema) => {
      return proposedSolutionStepType[0] === ProposedSolutionStep.keep ? schema : schema.required(t(Resources.Validation.Required));
    }),
    frequency: string().required(t(Resources.Validation.Required)),
    newFrequency: string().required(t(Resources.Validation.Required)),
    proposedSolutionStepType: string().required(t(Resources.Validation.Required)),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
